/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * HTTP method for callback
 */
export type GetScheduledBotResponseDataCallbackConfigAnyOfMethod =
  (typeof GetScheduledBotResponseDataCallbackConfigAnyOfMethod)[keyof typeof GetScheduledBotResponseDataCallbackConfigAnyOfMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduledBotResponseDataCallbackConfigAnyOfMethod = {
  POST: "POST",
  PUT: "PUT"
} as const
